export let MessageKey;

(function (MessageKey) {
  MessageKey["NoCreditCardNeededCrm"] = "NO_CREDIT_CARD_NEEDED_CRM";
  MessageKey["NoCreditCardNeededMarketing"] = "NO_CREDIT_CARD_NEEDED_MARKETING";
  MessageKey["RedLaughingGlasses"] = "RED_LAUGHING_GLASSES";
  MessageKey["Flywheel"] = "FLYWHEEL";
  MessageKey["SurveyMonkeyQuote"] = "SURVEY_MONKEY_QUOTE";
  MessageKey["AnneHubspot"] = "ANNE_HUBSPOT";
  MessageKey["BlueGreyBeardGlasses"] = "BLUE_GREY_BEARD_GLASSES";
  MessageKey["SocialProofLogos"] = "SOCIAL_PROOF_LOGOS";
  MessageKey["CheckYourEmail"] = "CHECK_YOUR_EMAIL";
  MessageKey["PasswordLock"] = "PASSWORD_LOCK";
  MessageKey["GirlSmilingPinkJacket"] = "GIRL_SMILLING_PINK_JACKET";
  MessageKey["GlassesColourfulScarf"] = "GLASSES_COLOURFUL_SCARF";
  MessageKey["ShortBlackHairSmiling"] = "SHORT_BLACK_HAIR_SMILING";
  MessageKey["LongBrownHairRed"] = "LONG_BROWN_HAIR_RED";
  MessageKey["MarketingIndustries"] = "MARKETING_INDUSTRIES";
  MessageKey["PersonWithBox"] = "PERSON_WITH_BOX";
  MessageKey["Hands"] = "HANDS";
  MessageKey["WhiteHouse"] = "WHITE_HOUSE";
  MessageKey["GetStartedWithSalesHub"] = "GET_STARTED_WITH_SALES_HUB";
  MessageKey["GetStartedWithDeveloperAccount"] = "GET_STARTED_WITH_DEVELOPER_ACCOUNT";
  MessageKey["SalesLogos"] = "SALES_LOGOS";
  MessageKey["CrmCentralPlace"] = "CRM_CENTRAL_PLACE";
  MessageKey["SalesQuote"] = "SALES_QUOTE";
  MessageKey["GetStartedWithServiceHub"] = "GET_STARTED_WITH_SERVICE_HUB";
  MessageKey["ServiceLogos"] = "SERVICE_LOGOS";
  MessageKey["ServiceQuote"] = "SERVICE_QUOTE";
  MessageKey["HubspotAcademy"] = "HUBSPOT_ACADEMY";
  MessageKey["AdritiAcademy"] = "ADRITI_ACADEMY";
  MessageKey["AcademyHat"] = "ACADEMY_HAT";
  MessageKey["KyleAcademy"] = "KYLE_ACADEMY";
  MessageKey["KaraAcademy"] = "KARA_ACADEMY";
  MessageKey["AcademyQuote"] = "ACADEMY_QUOTE";
  MessageKey["WordpressConnect"] = "WORDPRESS_CONNECT";
  MessageKey["GenericLandingPage"] = "GENERIC_LANDING_PAGE";
  MessageKey["BecomeASolutionsProvider"] = "BECOME_A_SOLUTIONS_PROVIDER";
  MessageKey["BlondeShelley"] = "BLONDE_SHELLEY";
  MessageKey["SolutionsDirectory"] = "SOLUTIONS_DIRECTORY";
  MessageKey["HubspotForNonProfitsLanding"] = "HUBSPOT_FOR_NON_PROFITS_LANDING";
  MessageKey["FreelanceDeveloperQuote"] = "FREELANCE_DEVELOPER_QUOTE";
  MessageKey["HubspotForStartupsLanding"] = "HUBSPOT_FOR_STARTUPS_LANDING";
  MessageKey["HubspotForPartnersLanding"] = "HUBSPOT_FOR_PARTNERS_LANDING";
  MessageKey["FreeMeetingSchedulingTools"] = "FREE_MEETING_SCHEDULING_TOOLS";
  MessageKey["EliminateScheduling"] = "ELIMINATE_SCHEDULING";
  MessageKey["AutomateYourSalesProcess"] = "AUTOMATE_YOUR_SALES_PROCESS";
  MessageKey["KeepAllYourMeetingsInSync"] = "KEEP_ALL_YOUR_MEETINGS_IN_SYNC";
  MessageKey["EmbedOrEmailYourCalendar"] = "EMBED_OR_EMAIL_YOUR_CALENDAR";
  MessageKey["TrialOpsPro"] = "TRIAL_OPS_PRO";
  MessageKey["TrialOpsEnt"] = "TRIAL_OPS_ENT";
  MessageKey["TrialSalesPro"] = "TRIAL_SALES_PRO";
  MessageKey["TrialSalesEnt"] = "TRIAL_SALES_ENT";
  MessageKey["TrialMarketingPro"] = "TRIAL_MARKETING_PRO";
  MessageKey["TrialMarketingEnt"] = "TRIAL_MARKETING_ENT";
  MessageKey["TrialServicePro"] = "TRIAL_SERVICE_PRO";
  MessageKey["TrialServiceEnt"] = "TRIAL_SERVICE_ENT";
  MessageKey["TrialCmsPro"] = "TRIAL_CMS_PRO";
  MessageKey["TrialCmsEnt"] = "TRIAL_CMS_ENT";
  MessageKey["HubSpotElevate"] = "HUBSPOT_ELEVATE";
  MessageKey["HubSpotStrategicPartner"] = "HUBSPOT_STRATEGIC_PARTNER";
  MessageKey["CMSHub"] = "CMS_HUB";
  MessageKey["GrowYourNetwork"] = "GROW_YOUR_NETWORK";
  MessageKey["FindYourDreamJob"] = "FIND_YOUR_DREAM_JOB";
  MessageKey["GetDiscovered"] = "GET_DISCOVERED";
  MessageKey["LearnNewSkill"] = "LEARN_NEW_SKILL";
  MessageKey["GetPaidDirectly"] = "GET_PAID_DIRECTLY";
  MessageKey["DIST008LiveChatLandingPage"] = "DIST008_LIVE_CHAT_LANDING_PAGE";
  MessageKey["DIST008LiveChatIndustry"] = "DIST008_LIVE_CHAT_INDUSTRY";
  MessageKey["DIST008LiveChatJobRole"] = "DIST008_LIVE_CHAT_JOB_ROLE";
  MessageKey["DIST008LiveChatCompanyName"] = "DIST008_LIVE_CHAT_COMPANY_NAME";
  MessageKey["DIST008LiveChatCompanySize"] = "DIST008_LIVE_CHAT_COMPANY_SIZE";
  MessageKey["DIST008LiveChatCompanyWebsite"] = "DIST008_LIVE_CHAT_COMPANY_WEBSITE";
  MessageKey["DIST008LiveChatCrmExperience"] = "DIST008_LIVE_CHAT_CRM_EXPERIENCE";
  MessageKey["DIST008LiveChatCrmPlatform"] = "DIST008_LIVE_CHAT_CRM_PLATFORM";
  MessageKey["DIST008MeetingsLandingPage"] = "DIST008_MEETINGS_LANDING_PAGE";
  MessageKey["DIST008MeetingsIndustry"] = "DIST008_MEETINGS_INDUSTRY";
  MessageKey["DIST008MeetingsJobRole"] = "DIST008_MEETINGS_JOB_ROLE";
  MessageKey["DIST008MeetingsCompanyName"] = "DIST008_MEETINGS_COMPANY_NAME";
  MessageKey["DIST008MeetingsCompanySize"] = "DIST008_MEETINGS_COMPANY_SIZE";
  MessageKey["DIST008MeetingsCompanyWebsite"] = "DIST008_MEETINGS_COMPANY_WEBSITE";
  MessageKey["DIST008MeetingsCrmExperience"] = "DIST008_MEETINGS_CRM_EXPERIENCE";
  MessageKey["DIST008MeetingsCrmPlatform"] = "DIST008_MEETINGS_CRM_PLATFORM";
  MessageKey["DIST008FormsLandingPage"] = "DIST008_Forms_LANDING_PAGE";
  MessageKey["DIST008FormsIndustry"] = "DIST008_Forms_INDUSTRY";
  MessageKey["DIST008FormsJobRole"] = "DIST008_Forms_JOB_ROLE";
  MessageKey["DIST008FormsCompanyName"] = "DIST008_Forms_COMPANY_NAME";
  MessageKey["DIST008FormsCompanySize"] = "DIST008_Forms_COMPANY_SIZE";
  MessageKey["DIST008FormsCompanyWebsite"] = "DIST008_Forms_COMPANY_WEBSITE";
  MessageKey["DIST008FormsCrmExperience"] = "DIST008_Forms_CRM_EXPERIENCE";
  MessageKey["DIST008FormsCrmPlatform"] = "DIST008_Forms_CRM_PLATFORM";
  MessageKey["ACQ117"] = "ACQ117";
})(MessageKey || (MessageKey = {}));